import { useLanguage } from "@/contexts/LanguageContext";
import { Eye } from "lucide-react";
import { HorizonZone } from "@/utils/horizonLayout";
import { m } from "framer-motion";

interface ShowAllButtonProps {
  zone: HorizonZone;
  hiddenCount: number;
  onToggle: () => void;
  isExpanded: boolean;
}

const ShowAllButton = ({ zone, hiddenCount, onToggle, isExpanded }: ShowAllButtonProps) => {
  const { language } = useLanguage();

  if (hiddenCount <= 0) return null;

  return (
    <m.button
      onClick={onToggle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="absolute right-1 md:right-2 z-30 flex items-center gap-1 px-2 py-1 rounded-full text-[10px] md:text-xs font-medium bg-card/90 backdrop-blur-sm border border-border shadow-sm hover:shadow-md transition-all cursor-pointer whitespace-nowrap"
      style={{
        bottom: `${((zone.visualBottom + zone.visualTop) / 2) * 100}%`,
        transform: "translateY(50%)",
        color: zone.color,
      }}
    >
      <Eye className="w-3 h-3" />
      {isExpanded
        ? (language === "fr" ? "Réduire" : "Collapse")
        : (language === "fr" ? `+${hiddenCount} marques` : `+${hiddenCount} brands`)}
    </m.button>
  );
};

export default ShowAllButton;
